import { SET_CRY_ANALYSER_RESULTS, IS_LOADING } from "./constants";

const initialState = {
  cryAnalyserReport: {},
  isLoading: false,
};

/**
 * Define the reducer with actions
 *
 * @param {Object} state
 * @param {Object} action
 */
function CryAnalyserReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CRY_ANALYSER_RESULTS:
      return {
        ...state,
        cryAnalyserReport: action.data,
      };

    case IS_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };

    default:
      return state;
  }
}

export default CryAnalyserReducer;
